<template>
  <div class="form-group mb-2">
    <label class="mb-1" :for="id">{{ label }}</label>
    <select
        class="form-select browser-default"
        :id="id"
        :name="id"
        :disabled="readonly"
        v-model="internalValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
      <option value="" selected disabled>{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectField',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Bitte auswählen'
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    modelValue: {
      type: [String, Boolean],
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>
